export default __webpack_public_path__ + "static/media/atthegates.333f2bbc.png";